import { Component, OnInit } from '@angular/core';
import { EventProjectService } from 'src/app/shared';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import * as QRCode from 'qrcode';
declare var $: any;
declare var Swal: any;

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

  galleryList: any[] = [];

  // รูป no data ใช้เมื่อ event ยังไม่มีรูปถ่าย
  readonly NO_PIC = 'assets/images/no-data.svg';

  // เก็บ id ของแถวที่เปิดเมนู action อยู่ (null = ปิดทั้งหมด)
  openActionId: string = null;

  constructor(
    private eventProjectService: EventProjectService,
    private spinner: NgxSpinnerService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.spinner.show();
    this.galleryList = [];
    this.eventProjectService.getGallery().subscribe(data => {
      this.galleryList = data || [];
      this.galleryList.forEach(item => {
        if (item.latest_file_manager_id) {
          item['thumbUrl'] =
            environment.api_domain + '/api/v1/files-view/' + item.latest_file_manager_id;
          item['hasImage'] = true;
        } else {
          item['thumbUrl'] = this.NO_PIC;
          item['hasImage'] = false;
        }
      });
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }

  // ถ้าโหลดรูป thumbnail ไม่สำเร็จ → สลับไปใช้รูป no data
  onThumbError(item: any) {
    if (item.thumbUrl !== this.NO_PIC) {
      item.thumbUrl = this.NO_PIC;
      item.hasImage = false;
    }
  }

  // ─── เมนู action list ─────────────────────────────────────────────
  toggleAction(id: string, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.openActionId = this.openActionId === id ? null : id;
  }

  closeAction() {
    this.openActionId = null;
  }

  // ไปหน้ารายการรูปถ่ายของ event นี้
  viewPhotos(item: any, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.closeAction();
    const tree = this.router.createUrlTree(['/list-photos'], {
      queryParams: { event_project_id: item.id }
    });
    const url = '#' + this.router.serializeUrl(tree);
    window.open(url, '_blank');
  }

  // สร้างลิงก์เว็บฝั่งลูกค้า (หน้า gallery แสดงรูปทั้งหมด) สำหรับ gallery นี้
  buildCustomerUrl(item: any): string {
    const base = (environment.customer_web_url || '').replace(/\/+$/, '');
    return base + '/?id=' + encodeURIComponent(item.id);
  }

  // สร้างลิงก์หน้าสไลด์โชว์ของ gallery นี้
  buildSlideshowUrl(item: any): string {
    const base = (environment.customer_web_url || '').replace(/\/+$/, '');
    return base + '/slideshow.html?id=' + encodeURIComponent(item.id);
  }

  // ─── แชร์ Gallery (ลิงก์ หน้าแสดงรูปทั้งหมด) ─────────────────────────
  shareGallery(item: any, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.closeAction();
    this.nativeShare(item.name || 'Gallery', this.buildCustomerUrl(item), 'ลิงก์แชร์ Gallery');
  }

  // ─── แชร์ สไลด์โชว์ (ลิงก์ หน้าสไลด์โชว์) ────────────────────────────
  shareSlideshow(item: any, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.closeAction();
    this.nativeShare(item.name || 'Gallery', this.buildSlideshowUrl(item), 'ลิงก์แชร์ สไลด์โชว์');
  }

  // ─── แชร์ QR Code Gallery ───────────────────────────────────────────
  shareGalleryQr(item: any, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.closeAction();
    this.showQrDialog('QR Code Gallery', this.buildCustomerUrl(item), 'สแกนเพื่อเปิด Gallery');
  }

  // ─── แชร์ QR Code สไลด์โชว์ ─────────────────────────────────────────
  shareSlideshowQr(item: any, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.closeAction();
    this.showQrDialog('QR Code สไลด์โชว์', this.buildSlideshowUrl(item), 'สแกนเพื่อเปิดหน้าสไลด์โชว์');
  }

  // แชร์แบบ native (navigator.share) → fallback คัดลอกลิงก์ → แสดง dialog ลิงก์
  private nativeShare(title: string, url: string, dialogTitle: string) {
    const nav = navigator as any;

    if (nav.share) {
      nav.share({ title: title, text: title, url: url }).catch(() => {});
      return;
    }

    if (nav.clipboard && nav.clipboard.writeText) {
      nav.clipboard.writeText(url).then(() => {
        Swal.fire({ type: 'success', title: 'คัดลอกลิงก์แล้ว', text: url });
      }).catch(() => {
        this.showLinkDialog(dialogTitle, url);
      });
      return;
    }

    this.showLinkDialog(dialogTitle, url);
  }

  private showLinkDialog(title: string, url: string) {
    Swal.fire({
      title: title,
      input: 'text',
      inputValue: url,
      showCancelButton: false,
      confirmButtonText: 'ปิด'
    });
  }

  // แสดง dialog QR Code ของลิงก์ที่กำหนด พร้อมปุ่มคัดลอกลิงก์
  private showQrDialog(title: string, url: string, hint: string) {
    QRCode.toDataURL(url, { width: 260, margin: 1 })
      .then((qrDataUrl: string) => this.renderQrDialog(title, url, hint, qrDataUrl))
      .catch(() => {
        // สร้าง QR ไม่ได้ → แสดง dialog ลิงก์แทน
        this.showLinkDialog(title, url);
      });
  }

  private renderQrDialog(title: string, url: string, hint: string, qrDataUrl: string) {
    const esc = (s: string) => (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    const html = `
      <div style="text-align:center;margin-bottom:14px;">
        <img src="${qrDataUrl}" alt="QR Code" style="width:220px;height:220px;" />
        <div style="font-size:12px;color:#888;margin-top:6px;">${esc(hint)}</div>
      </div>
      <div style="display:flex;gap:6px;">
        <input id="qrLinkInput" type="text" readonly value="${esc(url)}"
               style="flex:1;padding:7px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />
        <button type="button" id="qrCopyBtn"
                style="padding:7px 14px;border:none;border-radius:6px;background:#1f7a44;color:#fff;cursor:pointer;font-size:13px;">
          คัดลอก
        </button>
      </div>`;

    Swal.fire({
      title: title,
      html: html,
      showConfirmButton: true,
      confirmButtonText: 'ปิด',
      width: 360,
      onOpen: (modal: HTMLElement) => {
        const btn = modal.querySelector('#qrCopyBtn') as HTMLButtonElement;
        const input = modal.querySelector('#qrLinkInput') as HTMLInputElement;
        if (btn && input) {
          btn.addEventListener('click', () => {
            this.copyText(input.value, input);
            const original = btn.textContent;
            btn.textContent = 'คัดลอกแล้ว';
            setTimeout(() => { btn.textContent = original; }, 1500);
          });
        }
      }
    });
  }

  // คัดลอกข้อความลง clipboard (มี fallback สำหรับเบราว์เซอร์เก่า)
  private copyText(text: string, inputEl?: HTMLInputElement) {
    const nav = navigator as any;
    if (nav.clipboard && nav.clipboard.writeText) {
      nav.clipboard.writeText(text).catch(() => this.copyFallback(inputEl));
    } else {
      this.copyFallback(inputEl);
    }
  }

  private copyFallback(inputEl?: HTMLInputElement) {
    if (!inputEl) { return; }
    inputEl.focus();
    inputEl.select();
    try { document.execCommand('copy'); } catch (e) { /* ignore */ }
  }

  // ─── Delete gallery event: ลบรูปทั้งหมดภายใต้ gallery นี้ ──────────────
  openDeleteGallery(item: any, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    this.closeAction();

    if (!item.image_count || item.image_count === 0) {
      Swal.fire({
        type: 'info',
        title: 'ไม่มีรูปให้ลบ',
        text: 'Gallery นี้ยังไม่มีรูปถ่าย'
      });
      return;
    }

    Swal.fire({
      title: 'ลบรูปทั้งหมดใน Gallery นี้?',
      text: `ระบบจะลบรูปถ่ายทั้งหมด ${item.image_count} รายการ ภายใต้ "${item.name}" (ไม่สามารถกู้คืนได้)`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'ยืนยันลบ',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.eventProjectService.deleteGalleryImages(item.id).subscribe(() => {
          this.spinner.hide();
          this.successDialog();
          this.getAll();
        }, error => {
          this.spinner.hide();
          console.error(error);
          this.failDialog('');
        });
      }
    });
  }

  // ─── Dialog helpers ──────────────────────────────────────────────
  successDialog() {
    Swal.fire('ทำรายการสำเร็จ!', '', 'success');
  }

  failDialog(msg: string) {
    Swal.fire({
      type: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: msg
    });
  }
}
